import api from '../../api/app'
import {EventBus} from '../../event-bus.js';
import Vue from 'vue'

// initial state
const state = {
    all: [],
    responses: [],
    unsyncedResponses: [],
    recurrentSurveys: [],
    eventSurveys: [],
    goals: []
};

// getters
const getters = {}

// actions
const actions = {
    getSurveysList({commit, rootState}) {
        api.getSurveys(surveys => {
            commit('setSurveys', surveys);
        }, rootState.authentication.sessionToken)
    },
    destroySurveys({commit}) {
        commit('destroySurveys');
    },
    recordSurvey({commit, rootState}, payload) {
        api.recordSurvey(response => {
            if (response.status === 200) {
                setTimeout(function () {
                    EventBus.$emit('surveyRecorded', response);
                }, 500);
            } else {
                commit('addUnsyncedResponse', payload);
                Vue.notify({
                    group: 'app',
                    type: 'error',
                    title: 'Échec de l\'enregistrement',
                    text: 'Le serveur ne répond pas ou vous n\'êtes pas connecté à internet',
                });
                EventBus.$emit('surveyRecordError', response);
            }
        }, rootState.authentication.sessionToken, payload);
    },
    syncSurveys({state, commit, rootState}) {
        api.syncSurveys(response => {
            if (response.status === 200) {
                setTimeout(function () {
                    Vue.notify({
                        group: 'app',
                        type: 'success',
                        title: 'Les réponses sont synchronisées',
                        text: 'Toutes les réponses ont bien été envoyées au serveur',
                    });
                    commit('DeleteUnsyncedResponses');
                    EventBus.$emit('surveySyncSuccess', response);
                }, 500);
            } else {
                setTimeout(function () {
                    Vue.notify({
                        group: 'app',
                        type: 'error',
                        title: 'Échec de l\'enregistrement',
                        text: 'Le serveur ne répond pas ou vous n\'êtes pas connecté à internet',
                    });
                    EventBus.$emit('surveySyncError', response);
                }, 500);

            }
        }, rootState.authentication.sessionToken, state.unsyncedResponses);
    }
};

// mutations
const mutations = {
    setSurveys(state, surveys) {
        state.all = surveys;
        state.recurrentSurveys = surveys.data.recurrent;
        state.eventSurveys = surveys.data.events;
        state.goals = surveys.data.goals;
    },
    destroySurveys(state) {
        state.all = []
    },
    addUnsyncedResponse(state, payload) {
        state.unsyncedResponses.push(payload);
    },
    DeleteUnsyncedResponses(state) {
        state.unsyncedResponses = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
